import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';

import { AccountFaqListComponent } from './account-faq-list.component';
import { AccountFaqModule } from '../account-faq/account-faq.module';
import { AccountFaqCategoriesModule } from '../account-faq-categories/account-faq-categories.module';

@NgModule({
  declarations: [AccountFaqListComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    DropdownModule,
    DynamicDialogModule,
    InputTextModule,
    RippleModule,
    TableModule,
    AccountFaqModule,
    AccountFaqCategoriesModule,
  ],
  exports: [AccountFaqListComponent],
})
export class AccountFaqListModule {}
